/**
 * AttestApprovalViewer Parent Component
 * This component serves as the main container and can have child components inside "components/" folder.
 */
import React from "react";
import styles from "./AttestApprovalViewer.module.css";
import { useState, useEffect } from "react";
import { ThreeCircles } from "react-loader-spinner";
import { AttestApprovalViewerProps } from "./AttestApprovalViewer.utils";
import CygnusForm from "../../../../../Reusables/components/CygnusForm/CygnusForm";
import { FieldProps } from "../../../../../Reusables/components/InputFieldsController/InputFieldsController.utils";

/**
 * Full-screen modal for previewing forms before submission.
 */
export const AttestApprovalViewer: React.FC<
  AttestApprovalViewerProps
> = ({ sharedData, setSharedData, onValidationChange, onFormLoaded }) => {
  // State variables
  const [clientFormFields, setClientFormFields] = useState<FieldProps[]>(
    sharedData.attestFormData
  );
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (sharedData.attestFormData.length === 0) {
      setLoading(true);
    } else {
      setClientFormFields(sharedData.attestFormData);
      
      // Check if there are any fields with API dropdowns
      const hasApiDropdowns = sharedData.attestFormData.some(
        (field: { apiConfig: { apiKey: any; }; }) => field.apiConfig?.apiKey
      );
      
      // If no API dropdowns, set loading to false immediately
      if (!hasApiDropdowns) {
        setLoading(false);
        // Notify parent immediately if no dropdowns to load
        onFormLoaded?.('attest');
      }
    }
  }, [sharedData.attestFormData, onFormLoaded]);

  const handleDropdownsLoaded = () => {
    setLoading(false);
    // Notify parent that this form is fully loaded
    onFormLoaded?.('attest');
  };

  return (
    <>
      {loading && (
        <div className={styles.approvalLoader}>
          <div className="flex-row-center-center" style={{ marginLeft: 5 }}>
            <div style={{ width: "fit-content", padding: 0 }}>
              <ThreeCircles
                height="35"
                width="35"
                color="#4fa94d"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="three-circles-rotating"
                outerCircleColor="var(--theme1_tertiary)"
                innerCircleColor="var(--theme1_secondary)"
                middleCircleColor="var(--theme1_primary)"
              />
            </div>
            <h6 style={{ width: "fit-content", marginLeft: 10 }}>
              Loading your details
            </h6>
          </div>
        </div>
      )}
      
      <CygnusForm
        formId="cygnus-client-approval-attest-form"
        fields={clientFormFields}
        onFieldsChange={setClientFormFields}
        onValidationChange={() => {
          // NOT REQUIRED HERE
        }}
        onDropdownsLoaded={handleDropdownsLoaded}
        fieldVariant={sharedData.attestFieldVariant}
        sectionVariant={sharedData.attestSectionVariant}
        sectionLayout={sharedData.attestSectionLayout}
      />
    </>
  );
};

export default AttestApprovalViewer;